/*  eslint-disable react/default-props-match-prop-types */
import React, { FunctionComponent } from 'react';
import { makeStyles } from '~/UIKit/Style';

const useStyles = ({ height, width }: IWrapper) =>
  makeStyles({
    wrapper: { width, height },
  });

interface IWrapper {
  width?: number | string;
  height?: number | string;
}
interface IllustrationProps extends IWrapper {
  svg: FunctionComponent;
}

const Illustration = ({ height, width, svg }: IllustrationProps) => {
  const { classes } = useStyles({ height, width })();
  const SvgComponent = svg;
  return (
    <div className={classes.wrapper}>
      <SvgComponent />
    </div>
  );
};

Illustration.defaultProps = {
  width: 100,
  height: 'auto',
};

export default Illustration;
